import PropTypes from "prop-types";
import React from "react";
import { Loader as LoaderAnim } from "react-loaders";

const Spinner = <LoaderAnim color="#545cd8" type="line-scale" active />;

export default Spinner;
